import { render, staticRenderFns } from "./rewardExchangeStoreEdit.vue?vue&type=template&id=04c0339f&scoped=true&"
import script from "./rewardExchangeStoreEdit.vue?vue&type=script&lang=js&"
export * from "./rewardExchangeStoreEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0339f",
  null
  
)

export default component.exports